export default __webpack_public_path__ + "static/defi-iph-mockup-mobile-5a337be67bd3bbbf7d3295bb5cb96da9.png";